export const basesPointToDecimal = (basesPoint: number) => basesPoint / 10000;
